import { render, staticRenderFns } from "./CardSlider.vue?vue&type=template&id=294c0d3c"
import script from "./CardSlider.vue?vue&type=script&lang=js"
export * from "./CardSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports